export enum PlanType {
  None = 'None',
  All = 'All',
  SelectedFeatures = 'SelectedFeatures',
}

export enum PlanFeature {
  DocumentationAgent = 'DocumentationAgent',
  ProcessOptimizationAgent = 'ProcessOptimizationAgent',
  MonitoringAgent = 'MonitoringAgent',
  PermissionsAgent = 'PermissionsAgent',
}
